// @ constants
const contactCenterActionTypes = require('constants/contactCenter/actionTypes');
const actionTypes = require('constants/actionTypes');

// @ utils
const usd = require('utilities/usd');

const clearRequest = () => ({
    type: contactCenterActionTypes.CUSTOMER_FINDER_CLEAR_REQUEST
});

const cleanReducers = () => ({
    type: actionTypes.LOGOUT_SUCCESS
});
const endInteraction = () => dispatch => {
    window.notifyInteractionEnded();
    usd.resetClient();
    dispatch(cleanReducers());
    dispatch(clearRequest());
}

module.exports = {
    clearRequest,
    endInteraction
};
